export default __webpack_public_path__ + "static/media/none.919befaa.svg";